import { addCreateDocumentOption } from '../../utils/addCreateDocumentOption';
import { renderEmptyContainer } from '../../utils/renderEmptyContainer';

export function renderHtmlNode(node, options = {}) {
  addCreateDocumentOption(options);
  const document = options.createDocument();

  const html = node.html;

  if (!html) {
    return renderEmptyContainer(document);
  }

  const textarea = document.createElement('textarea');
  textarea.innerHTML = `\n<!--editor-begin: html-->\n${html}\n<!--editor-end: html-->\n`;

  // `type: 'value'` will render the value of the textarea element
  return { element: textarea, type: 'value' };
}
